import React, { Suspense, useState } from "react";
import { FiShare2 } from "react-icons/fi";
import { Modal } from "../Modal";
import { LoadingSpinner } from "../LoadingSpinner";

const TypeUsageGraph = React.lazy(() => import("./TypeUsageGraph"));

/**
 * "Show connections" for a single content page: opens a clickable graph of how this page connects : * the pages it links to, the pages that link to it, and its layout references. Mirrors the architecture
 * graph but focused on one page; clicking a node opens that page in the editor.
 */
const PageConnectionsButton: React.FC<{
	pageId: string;
	pageTitle?: string;
	language?: string;
	className?: string;
	label?: string;
}> = ({ pageId, pageTitle, language = "fr", className, label = "Connexions" }) => {
	const [open, setOpen] = useState(false);
	return (
		<>
			<button
				type="button"
				onClick={() => setOpen(true)}
				className={
					className ??
					"inline-flex items-center gap-1.5 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-50"
				}
				title="Voir les connexions de cette page"
			>
				<FiShare2 className="h-3.5 w-3.5" /> {label}
			</button>
			<Modal show={open} onHide={() => setOpen(false)} size="full85" centered dialogClassName="min-h-[80vh]">
				<Modal.Header closeButton>
					<Modal.Title className="text-lg font-semibold text-foreground">
						Connexions : {pageTitle ?? "page"}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body className="flex min-h-0 flex-col bg-muted/30">
					<p className="mb-2 text-xs text-slate-500">
						Comment cette page est connectée : les pages vers lesquelles elle pointe (à droite), celles qui pointent
						vers elle (à gauche) et ses éléments de mise en page. Cliquez sur un nœud pour l'ouvrir.
					</p>
					{open && (
						<Suspense
							fallback={
								<div className="flex flex-1 items-center justify-center p-10">
									<LoadingSpinner size="lg" />
								</div>
							}
						>
							<TypeUsageGraph pageId={pageId} language={language} />
						</Suspense>
					)}
				</Modal.Body>
			</Modal>
		</>
	);
};

export default PageConnectionsButton;
